import { Flex, Box, Tooltip, Icon } from '@chakra-ui/react';
import { InfoCircle } from '@kula-ai/icons/outline/InfoCircle';
import { Title } from '../../components/Title';

export const TitleWithTooltip = ({
  label,
  metricDefinition,
}: {
  label: string;
  metricDefinition: string;
}) => {
  return (
    <Flex alignItems="center">
      <Title text={label} />
      <Box flex="1" ml="12px" _groupHover={{ display: 'flex' }}>
        <Tooltip variant="default" label={metricDefinition} placement="top">
          <span>
            <Icon cursor="pointer" w="16px" h="16px" as={InfoCircle} />
          </span>
        </Tooltip>
      </Box>
    </Flex>
  );
};
